import { render, staticRenderFns } from "./assignperk.vue?vue&type=template&id=40e0e549&scoped=true"
import script from "./assignperk.vue?vue&type=script&lang=js"
export * from "./assignperk.vue?vue&type=script&lang=js"
import style0 from "./assignperk.vue?vue&type=style&index=0&id=40e0e549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e0e549",
  null
  
)

export default component.exports